import {oceanBlueColor, grayColor, redColor} from '../../cmsMainStyle'

const confirmDialogStyle = theme => ({
	content: {
		color: grayColor[12]
	},

	attentionContent: {
		color: redColor[10],
		fontSize: 10
	},

	actionButton: {
		color: oceanBlueColor[13],
		fontSize: 15,
		fontWeight: 600,
	}
})


export {confirmDialogStyle}